import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { decryptData, formatDateToMM } from "utils";

function PreviewBilling(props) {
  const [billingInfo, setBillingInfo] = useState([]);
  const [ccDetails, setCCDetails] = useState({});
  const [total, setTotal] = useState(0);
  useEffect(() => {
    const billingInfo = JSON.parse(
      decryptData(localStorage.getItem("billing"))
    );
    const ccDetails = JSON.parse(
      decryptData(localStorage.getItem("ccDetails"))
    );
    if (billingInfo) {
      setTotal(billingInfo.reduce((a, b) => a + +b.transactionAmount, 0));
      setBillingInfo(billingInfo);
      setCCDetails(ccDetails);
    } else {
      setBillingInfo("out");
    }
  }, []);

  if (billingInfo === "out") {
    return <Redirect to="/mirror/account" />;
  }
  return (
    <div className="preview_billing billing">
      <div className="billing_head">
        <div className="logo">
          <div className="icon">
            <img src="https://www.idrivemirror.com/webapp/images/blue_mirror_logo.svg" />
          </div>
        </div>
        <div className="billing_history">
          <div className="header_title">Transaction Summary</div>
          <div className="print_transaction_summary">
            <a className="print" onClick={() => window.print()}>
              <span className="pts_icon" />
              <span className="pts_title">Print</span>
            </a>
          </div>
        </div>
        <div className="pb_name_plan">
          <div className="pb_name_plan_item">
            <span className="fw_bold">Email:</span>{" "}
            <span>{props.userDetails.emailid}</span>
          </div>
          <div className="pb_name_plan_item">
            <span className="fw_bold">Plan Type:</span>{" "}
            <span>{props.plan.description}</span>
          </div>
        </div>
      </div>
      <div className="preview_billing_table">
        <div className="pb_charge">
          <span>Charges</span>
        </div>
        <ul className="pb_table_head">
          <li className="pb_item">
            <div className="pb_item_inner">
              <div className="pb_table_head_date fw_bold">Bill Date</div>
              <div className="pb_table_head_number fw_bold">Card Number</div>
              <div className="pb_table_head_amount fw_bold">Amount($)</div>
            </div>
          </li>
        </ul>
        <ul className="pb_table_body">
          {billingInfo &&
            billingInfo.map(bill => (
              <li className="pb_item pb_table_body_item">
                <div className="pb_item_inner">
                  <div className="pb_table_head_date">
                    {bill.transactionDate &&
                      formatDateToMM(bill.transactionDate.split(" ")[0])}
                  </div>
                  <div className="pb_table_head_number">
                    ************{bill.cardNumber}
                  </div>
                  <div className="pb_table_head_amount">
                    ${bill.transactionAmount}
                  </div>
                </div>
              </li>
            ))}
        </ul>
        <div className="pb_table_foot">
          <span className="fw_bold">Grand Total</span>
          <span>(including all charges and refund):</span>
          <span className="fw_bold"> ${total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userDetails: state.account.userDetails,
    plan: state.account.plan
  };
}

export default connect(mapStateToProps)(PreviewBilling);
